import { render, staticRenderFns } from "./organization-person.vue?vue&type=template&id=0f858f44&"
import script from "./organization-person.vue?vue&type=script&lang=js&"
export * from "./organization-person.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports